<template>
  <div class="container py-4">
    <h1>Política de Privacidade</h1>
    <p class="lead">Na eDomi prezamos pela sua privacidade. Esta página descreve como coletamos, usamos e protegemos seus dados.</p>
    <section class="mt-3">
      <h4>Informações que coletamos</h4>
      <p>Coletamos apenas informações necessárias para fornecer nossos serviços: cadastro, agendamento de visitas e comunicação.</p>
      <h4>Uso e armazenamento</h4>
      <p>Seus dados são utilizados para comunicação e melhoria do serviço. Não vendemos suas informações.</p>
      <h4>Contato</h4>
      <p>Para dúvidas sobre privacidade, envie um e-mail para contato@edomi.com.br</p>
    </section>
  </div>
</template>

<script setup>
</script>

<style scoped>
.lead { color: #254163; }
</style>
